<template>
  <div class="w-auto mx-auto p-6 bg-white rounded-lg shadow-md">
    <button label="close" @click="$emit('close')"></button>
    <h2 class="text-xl font-bold mb-4">Create new school</h2>

    <form @submit.prevent="submitForm" class="space-y-4">
      <div>
        <label class="block text-lg font-medium">School Name</label>
        <InputText v-model="form.name" class="w-full" required />
      </div>


      <div>
        <label class="block text-lg font-medium">School Level</label>
        <Dropdown
          v-model="form.level"
          :options="schoolLevel"
          option-label="label"
          option-value="label"
          placeholder="Select School level"
          class="w-full"
          required
        />
      </div>

      <div>
        <label class="block text-lg font-medium">Acronym</label>
        <InputText v-model="form.acronym" class="w-full" required/>
      </div>


      <div>
        <label class="block text-lg font-medium">Head Officer</label>
        <InputText v-model="form.head_officer" class="w-full" required />
      </div>

      <div>
        <label class="block text-lg font-medium">School Area Size</label>
        <InputText v-model="form.area_size" class="w-full"  />
      </div>

      <div>
        <label class="block text-lg font-medium">School Accreditation</label>
        <InputText v-model="form.accreditation" class="w-full"  />
      </div>
      <div>
        <label class="block text-lg font-medium">Address 1</label>
        <div class="flex row-auto gap-1">
          <InputText v-model="form.address1" class="w-full" required />

          <Button @click="showDialog = true" label="Map" class="w-30" />
        </div>
      </div>
      <div>
        <label class="block text-lg font-medium">Address 2</label>
        <InputText v-model="form.address2" class="w-full"  />
      </div>
      <div>
        <label class="block text-lg font-medium">City</label>
        <InputText v-model="form.city" class="w-full" required />
      </div>

      <div>
        <label class="block text-lg font-medium">Country</label>
        <InputText v-model="form.country" class="w-full" required />
      </div>

      <div>
        <label class="block text-lg font-medium">Zip Code</label>
        <InputText v-model="form.zip_code" class="w-full" required />
      </div>

      <div>
        <label class="block text-lg font-medium">Phone Number</label>
        <InputMask v-model="form.phone_number" class="w-full" mask="9999-999-9999" required />
      </div>

      <div>
        <label class="block text-lg font-medium">Email</label>
        <InputText v-model="form.email" type="email" class="w-full" required />
      </div>

      <div>
        <label class="block text-lg font-medium">Website</label>
        <InputText v-model="form.website_url" class="w-full" />
      </div>
      <div class="field">
            <label class="block text-lg font-medium">Date Founded</label>
            <Calendar
              v-model="form.date_founded"
              class="w-full"
              dateFormat="yy-mm-dd"
              showIcon
              required
            />
          </div>

      <Button type="submit" label="Submit" class="w-full" />
    </form>
      <Dialog v-model:visible="isloading"
  :modal="true"
  :closable="false"
  header=""
  :style="{ width: '90vw', maxWidth: '400px' }"
  :breakpoints="{ '960px': '75vw', '641px': '90vw' }">
        <LoadingComp :loadingType="'Saving ' + form.name + ' details...'" />
        </Dialog>
    <Dialog
      v-model:visible="showDialog"
      modal
      :style="{ width: '50vw', position: 'absolute', top: '10vh' }"
      position="top"

    >
      <GeoLocation @close="showDialog = false"  @handle-address="handleSubmit"/>
    </Dialog>

    <Dialog v-model:visible="successDialogVisible"  modal header="Success" :closable="false" :style="{ width: '400px' }">
      <div class="-dialogsuccess items-center justify-center">
        <i class="pi pi-check-circle success-icon"></i>
        <p>School added successfully!</p>
      </div>
      <template #footer>
        <Button label="OK" @click="successDialogVisible = false; emit('close')" />
      </template>
    </Dialog>

    <Dialog v-model:visible="errorDialogVisible" modal header="Error" :style="{ width: '30vw' }">
      <div class="-dialogsuccess">
      <i class="pi pi-exclamation-triangle text-red-500 text-[3rem]"></i>
      <p>Failed to add school. Please try again.</p>
      </div>
      <template #footer>
        <Button label="OK" @click="errorDialogVisible = false" />
      </template>
    </Dialog>
  </div>
</template>

<script setup>
import { ref, defineEmits, onMounted } from 'vue'
import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'
import Dropdown from 'primevue/dropdown'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import BaseInput from '@/components/inputs/BaseInput.vue'
import { useSchoolStore } from '@/store/admin/StoreSchool.js'
import GeoLocation from '@/components/GeoLocation.vue'
import { useAuthStore } from '@/auth/auth'
import LoadingComp from '@/components/LoadingComp.vue'
import { useGradeStore } from '@/store/admin/GradeLevelStore'
import { storeToRefs } from 'pinia'


const gradeStore = useGradeStore()
const { grade } = storeToRefs(gradeStore)

const authStore = useAuthStore()
const isloading = ref(false)

const schoolStore = useSchoolStore()

const showDialog = ref(false)
const addressgeo = ref('')

const zip_ = ref('')
const city_ = ref('')
const country_ = ref('')
const successDialogVisible = ref(false)
const errorDialogVisible = ref(false)

function handleSubmit(z) {
  showDialog.value = false

  form.value.address1 = z.address.split(',')[0].trim() + ' ' + z.address.split(',')[1].trim()
  form.value.address2 = z.address.split(',')[2].trim() + ' ' + z.address.split(',')[3].trim()
  form.value.city = z.city.trim()
  form.value.zip_code = z.zipCode.trim()
  form.value.country = z.country.trim()
}

const form = ref({
  name: '',
  address1: '',
  address2: '',
  city: '',
  country: '',
  zip_code: '',
  level: '',
  head_officer: '',
  division: 'San Fernando',
  area_size: '',
  website: '',
  acronym: '',
  phone_number: '',
  email: '',
  accreditation: '',
  date_founded:''
})

const showDrawer = ref(false)
const isEditing = ref(false)
const editingIndex = ref(null)

const locations = ['Location 1', 'Location 2', 'Location 3']
const sclLvl = ['Elementary School', 'Highschool', 'College']
const schoolYears = ['2023-2024', '2024-2025', '2025-2026']
const schoolTypes = ['Private', 'Public', 'Charot']

const schoolLevel = ref([])

const emit = defineEmits(['close'])

const submitForm = async () => {
  isloading.value = true
  // form.value.date_founded = form.value.date_founded
  //   ? form.value.date_founded.toISOString().split('T')[0]
  //   : ''
    const dateFoundedFormatted = form.value.date_founded instanceof Date
    ? form.value.date_founded.toISOString().split('T')[0]
    : form.value.date_founded;

    const payload = {
    ...form.value,
    date_founded: dateFoundedFormatted
  };
  const concatenatedValues = Object.values(payload)
    .map(val => String(val || ''))
    .join('');

  payload.signature = authStore.hashText(concatenatedValues);

//     const { signature, ...fields } = form.value;

// const concatenatedValues = Object.values(fields)
//   .map(val => String(val || '')) // Convert to string and handle null/undefined
//   .join('');

// form.value.signature =  authStore.hashText(concatenatedValues)

  const result = await schoolStore.addSchool(payload)
  isloading.value = false
  if (result.data.status === 'success') {
    successDialogVisible.value = true
  } else {
    console.error('Failed to add school:', result.data || result.message)
    errorDialogVisible.value = true
  }
}

onMounted(async () =>{
  await  gradeStore.getGrades()
  schoolLevel.value = grade.value.map(item => ({
    label: item.name,
    value: item.pid
  }))

})

function formatDateToISO(timestamp) {
  const date = new Date(timestamp)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}
</script>

<style>
.success-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 1rem 0;
}
.success-icon {
  font-size: 3rem;
  color: #22c55e;
}
.-dialogsuccess { /* Add this new style or modify the existing one */
  text-align: center;
}

</style>
